import { pagesText } from '../../constants/pagesText';
import { PORTAL_ROUTE } from '../../constants/routes';

const navConfig = [
  {
    title: pagesText.sidebarNavigation.dashboard,
    path: `${PORTAL_ROUTE}/devices-dashboard`,
    icon: 'ic:baseline-space-dashboard',
    canNavigate: true,
  },
  {
    title: pagesText.sidebarNavigation.WDACResults,
    path: `${PORTAL_ROUTE}/wdac-results/win32-apps`,
    icon: 'carbon:result',
    canNavigate: true,
  },
  {
    title: pagesText.sidebarNavigation.apps,
    path: `${PORTAL_ROUTE}/apps`,
    icon: 'basil:file-download-outline',
    canNavigate: true,
  },
  {
    title: pagesText.sidebarNavigation.devices,
    path: `${PORTAL_ROUTE}/devices`,
    icon: 'ic:baseline-devices',
    canNavigate: true,
  },
  {
    title: pagesText.sidebarNavigation.license,
    path: `${PORTAL_ROUTE}/license`,
    icon: 'mingcute:badge-line',
    canNavigate: true,
  },
  {
    title: pagesText.sidebarNavigation.actions,
    path: `${PORTAL_ROUTE}/actions`,
    icon: 'quill:checkmark-double',
    canNavigate: true,
  },
];

export default navConfig;
